/**
 * The "shared" `CollectionView` extension for supporting the concept of a view scope within `CollectionView`'s.
 */
define((require) => {
    "use strict";

    const {CollectionView} = require("marionette");
    const ViewScope        = require("shared/ui/common/ViewScope");

    const superRenderItemView = CollectionView.prototype.renderItemView;

    CollectionView.prototype.renderItemView = function(view, index) {
        view.parentView = this;
        ViewScope.register(this, view);

        superRenderItemView.call(this, view, index);
    };
});



// WEBPACK FOOTER //
// ./src/shared/zbone/CollectionView.js